// extracted by mini-css-extract-plugin
module.exports = {"MainNav":"MainNav--FxKce","headerDesc":"headerDesc--2DnUv","leftCon":"leftCon--ytsQe","middleCon":"middleCon--CtBaz","rightCon":"rightCon--3JjcK","languageClass":"languageClass--3ZbbG","TopNav":"TopNav--1Otzy"};
    if(module.hot) {
      // 1675232528918
      var cssReload = require("/workspace/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  